// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

type GenericListItem = {id: string; name: string};

export interface DialogData_GenericSelectionDialogInput<T extends GenericListItem> extends MatDialogDataBaseInput {
	availableItems: T[];
	selectedItemId: string;
	titleToken: string;
}

export interface DialogData_GenericSelectionDialogOutput extends MatDialogDataBaseOutput {
	selectedItemId: string;
}

@Component({
	selector: "sim-generic-selection-dialog",
	templateUrl: "./generic-selection-dialog.component.html",
	styleUrl: "./generic-selection-dialog.component.scss",
	standalone: false,
})
export class GenericSelectionDialogComponent<T extends GenericListItem> extends BasicMaterialDialog<
	GenericSelectionDialogComponent<T>,
	DialogData_GenericSelectionDialogInput<T>,
	DialogData_GenericSelectionDialogOutput
> {
	public selectedItemId: string = null;

	constructor(_injector: Injector) {
		super(_injector);
	}

	public ngOnInit() {
		this.selectedItemId = this.data.selectedItemId;
	}

	public onSelectionChange(itemId: string) {
		this.selectedItemId = itemId;
	}

	public ok() {
		this.close({
			action: "ok",
			selectedItemId: this.selectedItemId,
		});
	}
}
